import React from 'react';
import { Box, Typography, Button, Alert } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

const ErrorState = ({ 
  height = 400, 
  message = "Something went wrong", 
  onRetry = null,
  severity = "error" 
}) => (
  <Box 
    display="flex" 
    flexDirection="column"
    justifyContent="center" 
    alignItems="center" 
    height={height}
    gap={2}
    p={2}
  >
    <Alert severity={severity} sx={{ mb: 2 }}>
      <Typography>{message}</Typography>
    </Alert>
    {onRetry && (
      <Button 
        variant="outlined" 
        startIcon={<RefreshIcon />}
        onClick={onRetry}
      >
        Retry
      </Button>
    )}
  </Box>
);

export default ErrorState;
